import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import ApiCaller from '../infrastructure/api/ApiCaller';
import { Redirect } from 'react-router-dom';
import { getSite } from '../infrastructure/site/SiteProvider';
import { getLoggedInBruger } from '../infrastructure/Security';
import BrugerEdit from './bruger/BrugerEdit';
import { PageWrapper } from '../uiComponents/layout/PageWrapper';
import { ContentWrapper } from '../uiComponents/layout/ContentWrapper';
import { SectionGroup } from '../uiComponents/layout/SectionGroup';
import { Section } from '../uiComponents/layout/Section';
import { Spinner } from '../uiComponents/Spinner';
import { Bruger } from '../models/Bruger';
import { setHoldListCache } from '../infrastructure/HoldListCache';

export interface AuthProps extends RouteComponentProps<any> {
  isUdvikling?: boolean;
}

export interface AuthState {
  authenticated: boolean;
  brugerExists?: boolean;
  brugerWasSaved: boolean;
}

class Auth extends React.Component<AuthProps, AuthState> {
  constructor(props: AuthProps) {
    super(props);

    this.state = { authenticated: false, brugerWasSaved: false };
    this.onAuthenticated = this.onAuthenticated.bind(this);
    this.onBrugerSaved = this.onBrugerSaved.bind(this);
  }

  componentDidMount() {
    const apiCaller = new ApiCaller();

    if (this.props.isUdvikling) {
      apiCaller.loginUdvikling().then((json: any) => {
        this.onAuthenticated(json);
      });
    } else {
      const authCode = encodeURIComponent(this.props.location.search);
      apiCaller.login(authCode).then((json: any) => {
        this.onAuthenticated(json);
      });
    }
  }

  onBrugerSaved(bruger: Bruger) {
    this.setState({ brugerWasSaved: true });
  }

  onAuthenticated(json: any) {
    if (json.ingenInstitutionstilknytninger !== undefined) {
      window.location.href = '/ingen-institutioner';
    } else {
      const apiCaller = new ApiCaller();
      localStorage.setItem('token', json.token);
      apiCaller.getHoldList().then((hold) => {
        this.setState({ authenticated: true });
        setHoldListCache(hold);

        const self = this;
        apiCaller
          .brugerStamdataSat(getLoggedInBruger().brugernavn)
          .then((exists: boolean) => self.setState({ brugerExists: exists }));
      });
    }
  }

  getReturnPath(): string {
    const fullPath = this.props.location.pathname;
    let returnPath = '';

    if (fullPath.indexOf('/auth') > -1) {
      const replaceWithPath =
        localStorage.getItem('tilmeld') !== null ? 'tilmelding' : '';
      returnPath = decodeURIComponent(
        fullPath.replace('/auth', replaceWithPath)
      );
      localStorage.removeItem('tilmeld');
    }
    return returnPath;
  }

  render() {
    if (this.state.brugerWasSaved) {
      return <Redirect to={'/' + this.getReturnPath()} />;
    }
    if (this.state.authenticated && this.state.brugerExists !== undefined) {
      const headerText = 'Velkommen til ' + getSite().navn;

      if (this.state.brugerExists) {
        return <Redirect to={'/' + this.getReturnPath()} />;
      } else {
        return (
          <PageWrapper>
            <ContentWrapper>
              <SectionGroup header={headerText}>
                <Section>
                  <div className="velkommen-wrapper">
                    <p>
                      Udfyld venligst lidt om dig selv nedenfor. Dette skal kun
                      gøres én gang.
                    </p>
                    <BrugerEdit
                      onBrugerSaved={this.onBrugerSaved}
                      isSubmitting={false}
                    />
                  </div>
                </Section>
              </SectionGroup>
            </ContentWrapper>
          </PageWrapper>
        );
      }
    } else {
      return <Spinner />;
    }
  }
}

export default Auth;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/auth.tsx